import { render, staticRenderFns } from "./UploadExcelBig.vue?vue&type=template&id=b4c5a0b0&scoped=true&"
import script from "./UploadExcelBig.vue?vue&type=script&lang=js&"
export * from "./UploadExcelBig.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcelBig.vue?vue&type=style&index=0&id=b4c5a0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5a0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
